export default __webpack_public_path__ + "static/trusted-201d715879cd517683504d494e204d59.svg";